import { gpHome } from '../app';
import { IAuthService } from '../services/auth-service';
import { IRouteAuthService, IRouteAuthServiceEvents } from '../services/route-auth-service';
import { IAuthorisationStatus } from '../../app-common/services/authorisation-checker-with-caching-service';
import { AppSettings } from '../app-settings';

interface IIndexControllerScope extends ng.IScope {
    authorisation: IAuthorisationStatus;
}

gpHome.controller('indexController', ['$scope', '$location', 'authService', 'gpRouteAuthService',
    function ($scope: IIndexControllerScope, $location: ng.ILocationService, authService: IAuthService, gpRouteAuthService: IRouteAuthService) {

        if (window.location.pathname === '/logout') {
            authService.logOut();
            // we do this so we don't see a flicker of a login screen while the page reloads.
            AppSettings.hideLoginUntilRefresh = true;
            window.location.href = "/";
        }

        const authEventOptions: IRouteAuthServiceEvents = {
            loggedIn: () => $location.path('/plans'),
            loggedOut: () => { },
        };

        authService.authorisationChanged(authStatus => {
            $scope.authorisation = authStatus;
        });

        gpRouteAuthService.register(authEventOptions);

        $scope.$on('$destroy', () => gpRouteAuthService.deregister(authEventOptions));
    }]);


